<template>
  <b-modal
    id="resetPasswordModal"
    hide-footer
    centered
    title="Password Reset"
    @hidden="resetModal"
    no-close-on-backdrop
  >
    <ValidationObserver v-slot="{ invalid }" ref="form">
      <b-form @submit.prevent="handleSubmit" class="mt-3">
        <div>
          <ValidationProvider
            vid="password"
            name="Password"
            rules="required"
            v-slot="{ errors }"
          >
            <b-form-group
              id="input-password"
              label="Password"
              label-for="password"
              class="modalLabel"
              ><b-form-input
                id="password"
                type="password"
                placeholder="Type Password"
                v-model="editFormData.password"
              ></b-form-input>
              <b-form-invalid-feedback :state="!errors.length">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            vid="password_confirmation"
            name="Confirm Password"
            rules="required"
            v-slot="{ errors }"
          >
            <b-form-group
              id="input-password_confirmation"
              label="Confirm Password"
              label-for="password_confirmation"
              class="modalLabel"
              ><b-form-input
                id="password_confirmation"
                type="password"
                placeholder="Type Confirm Password"
                v-model="editFormData.password_confirmation"
              ></b-form-input>
              <b-form-invalid-feedback :state="!errors.length">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
        </div>

        <div class="modalBtns mt-3">
          <b-button
            type="submit"
            variant="light"
            class="px-4 py-1"
            id="modalSubmitBtn"
            :disabled="invalid || isSubmitting"
            >Confirm</b-button
          >
          <b-button
            @click="$bvModal.hide('resetPasswordModal')"
            variant="light"
            class="px-4 py-1"
            id="modalCancelBtn"
          >
            Cancel
          </b-button>
        </div>
      </b-form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import passportApi from "@/apis/passport/index";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

const formData = {
  token: "",
  email: "",
  password: "",
  password_confirmation: "",
};

export default {
  name: "resetPassword",
  data() {
    return {
      isSubmitting: false,
      token: "",
      email: "",
      editFormData: {
        ...formData,
      },
    };
  },
  mounted() {
    //console.debug(this.$route.params.token);
    //console.debug(this.$route.query.email);

    this.editFormData.token = this.$route.params.token;
    this.editFormData.email = this.$route.query.email;
  },
  methods: {
    handleSubmit(e) {
      this.isSubmitting = true;
      passportApi
        .resetPassword(this.editFormData)
        .then((result) => {
          this.$emit("resetSuccessfully");

          this.$dialog
            .alert(
              "<div style='white-space: nowrap;'>Your new password has been set successfully!</div><div class='font-weight-400 mt-2'>Please login with your new password.</div>",
              {
                customClass: "dialog-alert",
              }
            )
            .catch(() => {
              this.$router.push({ name: "signin" });
            });
        })
        .catch((error) => {
          console.warn(error.response.data.errors);

          if (error.response.data.errors) {
            this.$refs.form.setErrors(error.response.data.errors);
            return;
          }

          this.$dialog.alert(error.response.data.message, {
            customClass: "dialog-alert",
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    resetModal() {
      this.editFormData = {
        ...formData,
      };
    },
  },
};

extend("required", {
  ...required,
  message: "The {_field_} is required",
});
</script>
